var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C15.525 0 13.5 2.025 13.5 4.5V67.5C13.5 69.975 15.525 72 18 72H63C65.475 72 67.5 69.975 67.5 67.5V18L49.5 0H18Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 18H67.5L49.5 0V13.5C49.5 15.975 51.525 18 54 18Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 31.5L54 18H67.5V31.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 58.5C58.5 59.7375 57.4875 60.75 56.25 60.75H6.75C5.5125 60.75 4.5 59.7375 4.5 58.5V36C4.5 34.7625 5.5125 33.75 6.75 33.75H56.25C57.4875 33.75 58.5 34.7625 58.5 36V58.5Z",
    fill: "#A066AA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9128 43.8008H18.7651C17.2013 43.8008 17.2013 41.499 18.7651 41.499H27.2746C28.8743 41.499 28.8743 43.8008 27.2746 43.8008H24.2888V52.884C24.2888 54.4478 21.9128 54.486 21.9128 52.884V43.8008Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5911 42.6308C30.5911 41.1548 32.9671 41.1008 32.9671 42.6308V52.8998C32.9671 54.3938 30.5911 54.4298 30.5911 52.8998V42.6308Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4908 43.8886V46.7483H43.0763C43.7243 46.7483 44.3723 47.3963 44.3723 48.0263C44.3723 48.6203 43.7243 49.1041 43.0763 49.1041H38.4908V52.8818C38.4908 53.5118 38.0408 53.9978 37.4108 53.9978C36.6188 53.9978 36.135 53.5118 36.135 52.8818V42.6646C36.135 42.0166 36.621 41.5486 37.4108 41.5486H43.7265C44.5185 41.5486 44.9865 42.0166 44.9865 42.6646C44.9865 43.2406 44.5185 43.8863 43.7265 43.8863H38.4908V43.8886Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.25 60.75H13.5V63H56.25C57.4875 63 58.5 61.9875 58.5 60.75V58.5C58.5 59.7375 57.4875 60.75 56.25 60.75Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTif);
export default __webpack_public_path__ + "static/media/tif.71ef12cef4df2ea2f870f0eeb4924989.svg";
export { ForwardRef as ReactComponent };